import { useEffect, useState, useCallback, useRef } from 'react';
import { workTicketsApi } from '../utils/api';

const POLL_INTERVAL_MS = 30000;

// Polls /work-tickets/print-clients/status so the staff UI can show whether
// the print station is online and (when offline) for how long.
export default function usePrintClientStatus() {
  const [status, setStatus] = useState({
    connected: null,           // null = unknown / loading
    clientCount: 0,
    lastConnectedAt: null,
    disconnectedSince: null,
    offlineDurationSec: 0
  });
  const mounted = useRef(true);

  const fetchStatus = useCallback(async () => {
    try {
      const res = await workTicketsApi.getStatus();
      if (!mounted.current) return;
      setStatus({
        connected: !!res.connected,
        clientCount: res.clientCount || 0,
        lastConnectedAt: res.lastConnectedAt || null,
        disconnectedSince: res.disconnectedSince || null,
        offlineDurationSec: res.offlineDurationSec || 0
      });
    } catch (err) {
      if (!mounted.current) return;
      // On error, surface as unknown rather than misleadingly "online"
      setStatus(prev => ({ ...prev, connected: null }));
    }
  }, []);

  useEffect(() => {
    mounted.current = true;
    fetchStatus();
    const interval = setInterval(fetchStatus, POLL_INTERVAL_MS);
    const onFocus = () => fetchStatus();
    window.addEventListener('focus', onFocus);
    return () => {
      mounted.current = false;
      clearInterval(interval);
      window.removeEventListener('focus', onFocus);
    };
  }, [fetchStatus]);

  return { ...status, refresh: fetchStatus };
}
